



































































































































































































































































import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import { groupCollectionByField } from '@/utils/common'
import { ContestacaoMedica, ContestacaoMedicaMensagem, TipoUsuarioEnum, RequestMessage, TipoMensagemEnum } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'

@Component

export default class ComponentModalContestacaoMedica extends Vue {
  @Prop({ required: false, default: 'hospital' }) tipoUsuario: string

  $refs!: { formJustificativaContestacao: any }
  formJustificativaContestacao: any = {
    valid: true,
    justificativa: '',
  }

  formJustificativaContestacaoRules: any = {
    justificativa: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  dialogContestacao: boolean = false
  loadingContestacaoNaoSatisfatoria: boolean = false

  async contestacaoNaoSatisfatoria() {
    this.loadingContestacaoNaoSatisfatoria = true
    if (this.$refs.formJustificativaContestacao.validate()) {
      this.getTexto = this.formJustificativaContestacao.justificativa
      await this.addMensagemManager(null, '', '', TipoMensagemEnum.Texto)
      await this.responder('recusarContestacao')
    }
    this.loadingContestacaoNaoSatisfatoria = false
  }

  @Watch('dialogContestacao')
  onChangeDialogContestacao(value: boolean) {
    if (!value) {
      this.formJustificativaContestacao.valid = true
      this.formJustificativaContestacao.justificativa = ''
      this.$refs.formJustificativaContestacao.resetValidation()
      this.loadingContestacaoNaoSatisfatoria = false
    }
  }

  texto: string = ''
  inputFiles: any[] = []
  loadClose: boolean = false
  loadUpload: boolean = false
  loadRecusar: boolean = false
  loadAceitar: boolean = false
  loadAddMensagem: boolean = false

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(value: boolean) {
    this.loadUpload = value
  }

  get loadingAceitar() {
    return this.loadAceitar
  }

  set loadingAceitar(value: boolean) {
    this.loadAceitar = value
  }

  get loadingRecusar() {
    return this.loadRecusar
  }

  set loadingRecusar(value: boolean) {
    this.loadRecusar = value
  }

  get loadingAddMensagem() {
    return this.loadAddMensagem
  }

  set loadingAddMensagem(value: boolean) {
    this.loadAddMensagem = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getShowModal() {
    const show = this.getBackofficeGlobalStore.modal.contestacaoMedica
    this.toggleHtmlOverflow(show)
    return show
  }

  set getShowModal(value: boolean) {
    this.getBackofficeGlobalStore.clearContestacaoMedica()
    if (value === false) {
      this.loadingClose = true
      this.getBackofficeGlobalStore.clearSolicitacao()
    }
    this.getBackofficeGlobalStore.setModal({ name: 'contestacaoMedica', value })
    this.loadingClose = false
  }

  get getContestacaoMedica() {
    return this.getBackofficeGlobalStore.contestacaoMedica
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get getMensagens() {
    return this.getBackofficeGlobalStore.contestacaoMedica.mensagens
      ? groupCollectionByField(this.getBackofficeGlobalStore.contestacaoMedica.mensagens) as any
      : []
  }

  get getTexto() {
    return this.texto
  }

  set getTexto(value: string) {
    this.texto = value
  }

  async getUser() {
    return this.$user
  }

  clearTexto() {
    this.getTexto = ''
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('l_main_scrollto')
    const option: ScrollToOptions = {
      behavior: 'smooth',
      left: 0,
      top: ele[0].scrollHeight + 1000,
    }

    ele[0].scrollTo(option)
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  formatHour(value: string) {
    return moment(value).format('HH:mm')
  }

  formatDate(value: string | Date) {
    return moment(value).format('DD/MM/YYYY')
  }

  async addMensagem() {
    if (this.getTexto) {
      this.loadingAddMensagem = true
      await this.addMensagemManager(null, '', '', TipoMensagemEnum.Texto)
      this.loadingAddMensagem = false
    }
  }

  async inputFile(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      this.loadingUpload = false
      return
    }

    const form = new FormData()
    form.append('documentos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm')

    const request = await this.getBackofficeGlobalStore.uploadDocumentoContestacao({
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      formData: form,
    })

    if (request.success) {
      const result = request.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result
      await this.addMensagemManager(documentoId, url, nomeArquivo, TipoMensagemEnum.Documento)
    }
    this.loadingUpload = false
  }

  async addMensagemManager(documentoId, url, nomeArquivo, tipoMensagem) {
    const time = moment().format('YYYY-MM-DDTHH:mm')
    const mensagemHospital = this.tipoUsuario === 'hospital'
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id

    const contestacaoMedicaMensagem: ContestacaoMedicaMensagem = {
      id: '',
      dataEnvio: time,
      tipoMensagem,
      mensagemHospital,
      texto: this.getTexto,
      documentoId,
      url,
      nomeArquivo,
    }

    const response = await this.getBackofficeGlobalStore.enviarMensagem({ solicitacaoId, contestacaoMedicaMensagem })

    if (response.data && response.data.solicitacao && this.tipoUsuario === 'medico') {
      await this.getSolicitacaoPendenciaStore.setAgendamentoMedico(response.data.solicitacao)
    }

    if (response.data && response.data.acaoMedicoResponse && this.tipoUsuario === 'medico') {
      await this.getSolicitacaoPendenciaStore.setAgendamentoMedico(response.data.acaoMedicoResponse.solicitacao)
    }

    this.clearTexto()
    this.scrollToMensagem()
  }

  async responder(action: string) {
    this.loadingAceitar = (action === 'aceitarContestacao')
    this.loadingRecusar = (action === 'recusarContestacao')

    const response = await this.getBackofficeGlobalStore[action]()
    if (response.data && response.data.solicitacao && this.tipoUsuario === 'hospital') {
      this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      EventBus.$emit('setSnackbar', {
        show: true,
        text: action === 'aceitarContestacao' ? 'Contestação aceita' : 'Contestação recusada',
        icon: action === 'aceitarContestacao' ? 'thumb_up' : 'thumb_down',
        color: '#2E7D32',
      })
    }
    this.clearTexto()
    this.getBackofficeGlobalStore.setModal({ name: 'contestacaoMedica', value: false })

    this.loadingAceitar = false
    this.loadingRecusar = false
    this.dialogContestacao = false
  }

  updated() {
    this.scrollToMensagem()
  }
}
